<seds-modal>
  <div content class="modal__content">
    <h1 class="modal__content__title">Criar usuário personalizado</h1>
    <p class="modal__content__text">
      A criação de um usuário com acesso a um grupo personalizado de produtos deve ser realizado pela nossa <span class="modal__text__link">Central de Ajuda</span>.
    </p>
  </div>
  <div class="modal__footer" footer>
    <seds-basic-button [size]="smallButton" title="Solicitar criação de usuário personalizado" (click)="openHelpUrl()"></seds-basic-button>
  </div>
</seds-modal>
